import axiosPost from "../../axiosPost";
import { respuestaDe } from "../../respuesta";

export const RNHAreaIns = async (credentials, data) => {
    const body = {
        service: "RNHAreaIns",
        params: {
            rnhAreaCod: data?.cod,
            rnhAreaNombre: data?.nombre,
            rnhZonaCod: data?.zonaCod,
            rnhAreaWKT: data?.wkt,
        },
    };

  return respuestaDe(await axiosPost(body, credentials));
};
